<div class="device-info">
    <div class="info-row">
        <span class="info-title">Browser</span>
        <span class="info-value">{{ browser }}</span>
    </div>
    <div class="info-row">
        <span class="info-title">Device OS</span>
        <span class="info-value">{{ os }}</span>
    </div>
</div>